import React, { Suspense, lazy, useEffect, useLayoutEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";

// Componentes globales (cargados perezosamente para optimizar)
const Footer = lazy(() => import("./components/Footer"));
const Scroll = lazy(() => import("./components/Scroll"));
const WhatsAppIcon = lazy(() => import("./components/WhatsAppIcon"));

// Nuevas páginas legales cargadas perezosamente
const Terminos = lazy(() => import("./pages/Terminos"));
const Privacidad = lazy(() => import("./pages/Privacidad"));

const ScrollManager = () => {
  const location = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname]);

  return null;
};

const App = () => {
  return (
    <Router>
      <ScrollManager />
      <div
        style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
      >
        {/* Navbar: visible en todas las páginas */}
        <Navbar />

        {/* Contenido principal */}
        <main style={{ flex: 1 }}>
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<HomePage />} />

              {/* Aquí agregamos las nuevas rutas legales */}
              <Route path="/terminos" element={<Terminos />} />
              <Route path="/privacidad" element={<Privacidad />} />

              {/* Cualquier otra URL redirige al inicio */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Suspense>
        </main>

        {/* Componentes flotantes y finales: visible en todas las páginas */}
        <Suspense fallback={null}>
          <WhatsAppIcon />
          <Scroll />

          <Footer />
        </Suspense>
      </div>
    </Router>
  );
};

export default App;
